import { styled } from "~/common/mui";
import { IMG_SPINNER } from "../../../utils/url/staticResources";

interface SpinnerProps {
  className?: string;
}

const StyledSpinner = styled("img")({
  width: "24px",
  height: "24px",
  display: "inline-block",
});

const CircleSpinner = (props: SpinnerProps) => {
  return <StyledSpinner {...props} src={IMG_SPINNER} />;
};

export default CircleSpinner;
